module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.entity,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": '优惠券' + _vm.coupon.sn,
      "closable": false
    }
  }, [_vm._v("\n\n      " + _vm._s((_vm.coupon.promotionInfo || {}).tip) + "\n    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "激活方式",
      "prop": "activeType"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.entity.activeType),
      callback: function($$v) {
        _vm.$set(_vm.entity, "activeType", $$v)
      },
      expression: "entity.activeType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "USERID"
    }
  }, [_vm._v("用户名")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "CARNUM"
    }
  }, [_vm._v("车牌号")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "激活KEY",
      "prop": "activeKey"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用户名或车牌号"
    },
    model: {
      value: (_vm.entity.activeKey),
      callback: function($$v) {
        _vm.$set(_vm.entity, "activeKey", _vm._n($$v))
      },
      expression: "entity.activeKey"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-daab8924","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/act/promotionCoupon/DispatchForm.vue
// module id = 355
// module chunks = 0